<template>
  <v-dialog v-model="open" width="600px">
    <v-card>
      <v-toolbar elevation="0" color="background">
        <v-toolbar-title class="pl-3 text--subtitle">
          <v-icon color="primary" style="padding-bottom: 2px">
            mdi-content-duplicate
          </v-icon>
          {{ $t('message.pages.duplicateVideoModal.title') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-row class="px-6 mb-2">
        <v-col>
          <v-col class="pa-0">
            <span>
              {{ $t('message.pages.duplicateVideoModal.message') }}
            </span>
            <div v-if="errors.duplicatingVideo" class="mt-2 text--error">
              <span>
                {{ $t('message.pages.duplicateVideoModal.errorMessage') }}
              </span>
              <template v-if="errors.status || errors.message">
                <br />
                <span v-if="errors.message">{{ errors.message }}.</span>
                <span v-else-if="errors.status"
                  >Status: {{ errors.status }}.</span
                >
              </template>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <v-card-actions class="px-8 pb-6">
        <v-spacer></v-spacer>
        <v-btn text class="mr-4 px-4" @click="open = false">
          {{ $t('message.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          class="px-10"
          :disabled="loadings.isDuplicating"
          :loading="loadings.isDuplicating"
          @click="handleDuplicate"
        >
          {{ $t('message.duplicate') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import videosApi from '@/services/videosApi.js'
import i18n from '@/translations/lang'

export default {
  name: 'DuplicateVideoModal',
  data: () => ({
    loadings: {
      isDuplicating: false,
    },
    errors: {
      duplicatingVideo: false,
      status: false,
      message: false,
    },
  }),
  props: {
    videoId: {
      type: String,
      required: true,
    },
    openModal: {
      type: Boolean,
      default: null,
    },
    goToDuplicatedVideo: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    open(val) {
      if (val === false) this.$root.$emit('VideoDuplicateModalHasClosed')
    },
  },
  computed: {
    open: {
      get() {
        return this.openModal
      },
      set(newValue) {
        if (!newValue) {
          this.$emit('close')
        }
      },
    },
  },
  mounted() {
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
  },
  methods: {
    handleChat() {
      this.$crisp.push(['do', 'chat:show'])
      this.$crisp.push(['do', 'chat:open'])
    },
    async handleDuplicate() {
      this.loadings.isDuplicating = true
      try {
        const { data } = await videosApi.cloneVideo(this.videoId)
        this.errors.duplicatingVideo =
          this.errors.status =
          this.errors.message =
            false
        const videoFormat = {
          title: data.title,
          id: data.id,
          status: data.status,
          folder_id: data.folder_id,
          updated_at: data.updated_at,
        }
        this.$root.$emit('addVideoVideosPage', videoFormat)
        if (this.goToDuplicatedVideo) {
          this.$root.$emit('goToDuplicatedVideo', data.id)
        }
        this.open = false
      } catch (e) {
        if (e.response?.status) {
          this.errors.status = e.response.status
        }
        if (e.response?.data?.errMsg) {
          const errorMessageTranslation = this.getErrorMessageTranslation(
            e.response.data?.errMsg,
            this.videoId
          )
          if (errorMessageTranslation) {
            this.errors.message = errorMessageTranslation
          }
        }
        this.errors.duplicatingVideo = true
        console.error(e)
      }
      this.loadings.isDuplicating = false
    },
    getErrorMessageTranslation(string, videoId = false) {
      if (string === 'Error to save clone in DB') {
        return i18n.t(
          'message.pages.duplicateVideoModal.responseErrors.saveInDB'
        )
      }
      if (string === 'Error to save clone in SQS') {
        return i18n.t(
          'message.pages.duplicateVideoModal.responseErrors.saveInSQS'
        )
      }
      if (string === 'Video is not in CONVERTED status') {
        return i18n.t(
          'message.pages.duplicateVideoModal.responseErrors.notConvertedStatus'
        )
      }
      if (
        string.includes('Video with video_id:') &&
        string.includes('was not found') &&
        videoId
      ) {
        return i18n.t(
          'message.pages.duplicateVideoModal.responseErrors.videoNotFound',
          { video_id: videoId }
        )
      }
      return false
    },
  },
}
</script>
